import React, { useState, useEffect } from 'react'
import { Modal, message, Tag, Table, Input, Alert } from 'antd'
import { updateFBAInfo } from '../../../../services/api/apiBarcode'

const { confirm } = Modal

function ModalFBAInfo(props) {
    const { visible = false, onClose, item = {}, reloadItems } = props || {}
    const [label, setLabel] = useState('')
    const [fnSkuMap, setFnSkuMap] = useState({})

    useEffect(() => {
        setLabel('')
        setFnSkuMap({})
    }, [visible])

    const handleChangeFnSkuNew = (fnSkuOld, value) => {
        setFnSkuMap(prev => {
            const next = { ...prev }
            if (!value) {
                delete next[fnSkuOld]
            } else {
                next[fnSkuOld] = value
            }
            return next
        })
    }

    const hasChanges = !!label || Object.keys(fnSkuMap).length > 0

    const handleSave = () => {
        confirm({
            title: 'Bạn có chắc chắn muốn cập nhật thông tin FBA?',
            onOk: async () => {
                const payload = {}
                if (label) payload.label = label
                if (Object.keys(fnSkuMap).length > 0) payload.fn_sku = fnSkuMap
                try {
                    const res = await updateFBAInfo(item.barcodeNumber, payload)
                    const { success, data = {}, message: mess } = res.data || {}
                    if (!success || !data.success) {
                        throw new Error(mess || 'Cập nhật FBA info thất bại')
                    }
                    message.success('Cập nhật FBA info thành công!')
                    onClose()
                    reloadItems()
                } catch (error) {
                    message.error(error.message)
                }
            },
        })
    }

    const products = Array.isArray(item.products) ? item.products : []

    const fnSkuGroups = Object.values(
        products.reduce((groups, product) => {
            const fnSku = product.fn_sku || ''
            if (!groups[fnSku]) {
                groups[fnSku] = { fn_sku: fnSku, quantity: 0 }
            }
            groups[fnSku].quantity += 1
            return groups
        }, {})
    )

    const columns = [
        {
            title: 'FN SKU hiện tại',
            dataIndex: 'fn_sku',
            key: 'fn_sku',
            render: (fn_sku) => fn_sku || '',
        },
        {
            title: 'Số lượng',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'FN SKU mới (để trống = giữ)',
            key: 'fn_sku_new',
            render: (_, group) => (
                <Input
                    value={fnSkuMap[group.fn_sku] || ''}
                    onChange={(e) => handleChangeFnSkuNew(group.fn_sku, e.target.value)}
                    placeholder="-"
                />
            ),
        },
    ]

    return (
        <Modal
            title={
                <span style={{ fontSize: 20 }}>
                    {`Cập nhật FBA info · Đơn #${item.barcodeNumber}`}
                    <Tag color="green" className="ml-2">FBA</Tag>
                </span>
            }
            className="ModalFBAInfo"
            visible={visible}
            okText="Lưu"
            cancelText="Hủy"
            okButtonProps={{ disabled: !hasChanges }}
            onCancel={onClose}
            onOk={handleSave}
            width={720}
        >
            <div className="ModalFBAInfoContent">
                <Alert
                    className="mb-3"
                    type="warning"
                    showIcon
                    message={
                        <span>
                            Áp dụng ở mọi trạng thái (kể cả đã vào thùng / đã ship). FN SKU sẽ được đồng bộ xuống các thùng tương ứng và gửi lại PLF.
                        </span>
                    }
                />

                <h3 style={{ fontSize: 16, color: 'rgba(0, 0, 0, 0.85)' }}>Lable item (split_fba_item_label)</h3>
                <div className="mb-3">
                    <div className="mb-1">Thay label mới (tùy chọn)</div>
                    <Input
                        value={label}
                        onChange={(e) => setLabel(e.target.value)}
                        placeholder="Dán Url label..."
                    />
                </div>

                <h3 style={{ fontSize: 16, color: 'rgba(0, 0, 0, 0.85)' }}>FN SKU (từ danh sách sản phẩm của đơn)</h3>
                <Table
                    dataSource={fnSkuGroups}
                    columns={columns}
                    rowKey="fn_sku"
                    pagination={false}
                />
                <div className="text-muted font-size-sm mt-2">
                    Phải thay đổi ít nhất label hoặc 1 FN SKU thì mới lưu được.
                </div>
            </div>
        </Modal>
    )
}

export default ModalFBAInfo
